import {
  useStyle 
} from "@/classify"
import Button from "@/components/Button"
import Field from "@/components/Field"
import TextInput from "@/components/TextInput"
import {
  usePassword 
} from "@/hooks/Password/usePassword"
import {
  isRequired 
} from "@/util/formValidators"
import React from "react"
import {
  Eye, EyeOff 
} from "react-feather"
import {
  useIntl 
} from "react-intl"
import defaultClasses from "./password.module.css"

const Password = (props) => {
  const {
    classes: propClasses,
    label,
    fieldName,
    isToggleButtonHidden = true,
    autoComplete,
    validate = isRequired,
    required = true,
    ...otherProps
  } = props

  const talonProps = usePassword()
  const {
    handleBlur, togglePasswordVisibility, visible 
  } = talonProps
  const classes = useStyle(defaultClasses, propClasses)

  const handleKeypress = (e) => {
    if (e.code == "Enter") {
      togglePasswordVisibility
    }
  }

  const {
    formatMessage 
  } = useIntl()
  const hidePassword = formatMessage({
    id: "password.hide",
    defaultMessage: "Hide Password",
  })
  const viewPassword = formatMessage({
    id: "password.view",
    defaultMessage: "View Password",
  })
  const speak = visible ? hidePassword : viewPassword

  const passwordButton = (
    <Button
      className={classes.passwordButton}
      onClick={togglePasswordVisibility}
      onKeyDown={handleKeypress}
      type='button'
    >
      {visible ? (
        <Eye aria-label={speak} />
      ) : (
        <EyeOff aria-label={speak} />
      )}
    </Button>
  )

  const fieldType = visible ? "text" : "password"

  return (
    <Field
      id='Password'
      label={label}
      classes={{
        root: classes.root,
        requiredLabel: classes.requiredLabel,
      }}
      required={required}
    >
      <TextInput
        after={!isToggleButtonHidden && passwordButton}
        autoComplete={autoComplete}
        field={fieldName}
        type={fieldType}
        validate={validate}
        onBlur={handleBlur}
        {...otherProps}
      />
    </Field>
  )
}

export default Password
